import { Component } from "react";
import {
  extract,
  CartContextConsumer,
  ECommerceHelper,
  EventAggregator,
  ProductStore,
  PrimaryButtonLink,
  SecondaryButton,
} from "@parksandresorts/core";
import styles from "./cart.module.less";
import CartItem from "components/block-elements/cart-item/cart-item";
import { GlobalContext } from "components/stores/global-context";

export default class Cart extends Component {
  static defaultProps = {
    hideContinueShopping: false,
  };

  constructor(props) {
    super(props);
    this.cartLabel = extract(ECommerceHelper, "jetshop.cartLabel");
    this.cartSummeryLabel = extract(ECommerceHelper, "jetshop.cartSummeryLabel");
    this.toCheckoutLabel = extract(ECommerceHelper, "jetshop.jetshopCheckoutUrl.title");
    this.continueShoppingLabel = extract(ECommerceHelper, "jetshop.continueShoppingLabel");
    this.toCheckoutUrl = extract(ECommerceHelper, "jetshop.jetshopCheckoutUrl.externalUrl");
    this.currencyDisplayName = extract(ECommerceHelper, "jetshop.currencyDisplayName");
    this.articleLabel = extract(ECommerceHelper, "jetshop.cartArticleLabel");
    this.articlesLabel = extract(ECommerceHelper, "jetshop.cartArticlesLabel");
    this.cartIsEmptyLabel = extract(ECommerceHelper, "jetshop.cartIsEmptyLabel");
    this.upsellPageUrl = extract(ECommerceHelper, "jetshop.upsellPageUrl");
    const hideContinueShopping = extract(props, "hideContinueShopping");
    this.showContinueShopping = !hideContinueShopping;

    this.state = {};
  }

  getCartLabel(itemsInCart) {
    if (itemsInCart && itemsInCart > 0) {
      return `${this.cartLabel} (${itemsInCart} ${itemsInCart > 1 ? this.articlesLabel : this.articleLabel})`;
    }
    return `${this.cartLabel} ${this.cartIsEmptyLabel}`;
  }

  isCartUpsellable(cartContext) {
    return (
      !cartContext.isUpsellVisited &&
      cartContext.upsellItems &&
      cartContext.upsellItems.length > 0 &&
      this.upsellPageUrl
    );
  }

  getCheckoutUrl(cartContext) {
    if (this.isCartUpsellable(cartContext)) {
      return this.upsellPageUrl;
    }
    return `${this.toCheckoutUrl}?CartID=${cartContext.cartId}`;
  }

  trackGoToCheckoutEvent(cartContext) {
    if (this.isCartUpsellable(cartContext)) {
      EventAggregator.publish("trackEvent", { category: "Cart", action: "Clicked button", label: "Upsale" });
    } else {
      const products = cartContext.products.map(async (product) => {
        const contentfulProduct = ProductStore.getProductByJetshopId(product.jetshopId);
        return {
          name: product.name,
          id: product.jetshopId,
          price: product.price,
          category:
            contentfulProduct && contentfulProduct.tags instanceof Array && contentfulProduct.tags.length
              ? contentfulProduct.tags[0].title
              : undefined,
          quantity: 1,
          glkId:
            contentfulProduct && contentfulProduct.productData.glkId
              ? parseInt(contentfulProduct.productData.glkId)
              : null,
        };
      });

      EventAggregator.publish("trackEvent", { category: "Cart", action: "Clicked button", label: "Checkout" });

      EventAggregator.publish("trackEcommerce", {
        event: "checkout",
        action: {
          checkout: {
            actionField: { step: 1 },
            products: products,
          },
        },
      });
    }
  }

  render() {
    return (
      <div className={styles.cart}>
        <CartContextConsumer>
          {(cartContext) => (
            <div className={styles.cart__fullView}>
              <div className={[styles.cart__title, "h4"].join(" ")}>{this.getCartLabel(cartContext.totalItems)}</div>
              {cartContext && (
                <ul className={styles.cart__list}>
                  {cartContext.products &&
                    cartContext.products.map((product) => {
                      return (
                        <li key={product.jetshopCartItemId} className={styles.cart__listItem}>
                          <CartItem {...product} cartContext={cartContext} />
                        </li>
                      );
                    })}
                </ul>
              )}

              <div className={styles.cart__checkoutWrapper}>
                <div className={styles.cart__sum}>
                  <span className={styles.cart__sumLabel}>{this.cartSummeryLabel}</span>
                  <span className={styles.cart__sumAmount}>{`${Math.round(cartContext.totalSumInclVat)} ${
                    this.currencyDisplayName
                  }`}</span>
                </div>
                <div className={styles.cart__bottomBtnWrapper}>
                  <span onClick={() => this.trackGoToCheckoutEvent(cartContext)}>
                    <PrimaryButtonLink
                      label={this.toCheckoutLabel}
                      isDisabled={!cartContext.products.length || cartContext.isLoading}
                      url={this.getCheckoutUrl(cartContext)}
                      className={["waves-effect", styles.checkoutBtn].join(" ")}
                      isFullWidth
                    />
                  </span>
                  {this.showContinueShopping && (
                    <SecondaryButton
                      complementary
                      label={this.continueShoppingLabel}
                      className={["waves-effect"].join(" ")}
                      onClick={() =>
                        this.context.setValue({
                          showCart: false,
                          showMenu: false,
                          showSearch: false,
                          isMenuAnimating: true,
                          isMenuAnimationDone: false,
                          isMainVisible: true,
                        })
                      }
                      isFullWidth
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </CartContextConsumer>
      </div>
    );
  }
}

Cart.contextType = GlobalContext;
